
<section :id="$style.Header" :class="$style.Header">
  <a :class="$style['header-logo']" :href="iconUrl">
    <img :src="s_icon" />
  </a>
  <span :class="$style['header-title']">{{ title }}</span>
</section>
